import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Location } from '@angular/common';
import { GlobalService } from '../services/global.service';
import { Moment } from 'moment';
import { EventSearchService } from './event-search.service';
import moment from 'moment';
import { AuthService } from 'src/app/core/account/auth.service';
import { SelectServiceService } from '../services/select-service.service';
import { ServiceGroup } from '../models/service-group.model';
import { ServiceVenue } from '../models/service-venue.model';
import { MemberSearch } from '../member-search/member-search.model';

@Component({
    selector: 'app-event-search',
    templateUrl: './event-search.component.html',
    styleUrls: ['./event-search.component.scss'],
    standalone: false
})
export class EventSearchComponent implements OnInit, OnChanges  {
  @Output() EventSearchLoaded = new EventEmitter();  
  @Input() AutoMode: boolean = false;
  isLoading: boolean = true;
  eventGroupId: number = 0;
  eventVenueId: number = 0;
  venue: string = "";
  myStartDate: Date; 
  groupArr: ServiceGroup[] = [];
  venueArr: ServiceVenue[] = [];
    
  constructor(
    public globalService: GlobalService,
    private _location: Location,
    public _eventSearch: EventSearchService, 
    private authService: AuthService,
    private selectService: SelectServiceService
  ) {} 

  async ngOnInit() {   
    await this.authService.autoLogin(1);
    if (this.globalService.eventDate == null) {
      this.myStartDate = new Date(new Date().toDateString());
      this.globalService.eventDate = this.myStartDate;
    } else this.myStartDate = this.globalService.eventDate;
    this.eventGroupId = this.globalService.eventService;
    this.eventVenueId = this.globalService.eventLocation;
    this.groupArr = await this.selectService.getActiveGroups();
    this.venueArr = await this.selectService.getActiveVenues();       
    if (this.eventVenueId == 0)
      this.venue = ""; 
    else  
    this.venue = this.venueArr.find(a => a.id == this.eventVenueId)?.name;
    if (this.venue == undefined)
      this.venue = "";
    await this._eventSearch.getEventsByDate(
      moment(this.myStartDate).format('YYYY-MM-DD'), this.eventGroupId, this.venue
    ); 
    this.initializeArr();
    this.EventSearchLoaded.emit(); 
    this.isLoading = false;
  }

  async ngOnChanges() {
    if (this.globalService.autoMode == true)
    {
      this.globalService.eventDate = new Date(new Date().toDateString());
      this.myStartDate = this.globalService.eventDate;
      this.globalService.eventService = 0;
      await this._eventSearch.getEventsByDate(
        moment(this.myStartDate).format('YYYY-MM-DD'), this.eventGroupId, this.venue
      ); 
      this.initializeArr();
      }
  }

  goHome() {
    this.globalService.clearCurCache = false;
    // this.globalService.isBack = true;
    this.globalService.eventDate = null;
    this.globalService.eventService = 0;
    this.globalService.eventLocation = 0;
    this._location.back();
  } 
  
  initializeArr()
  {
    this._eventSearch.eventArr.forEach(a => 
      { 
        a['user'] = new MemberSearch();
        a['user']['expandFunctions'] = false;
    }
    );
  }
 
  async DateChange(event) {
    const m: Moment = event.value;
    this.globalService.eventDate = event.value;
    await this._eventSearch.getEventsByDate(moment(event.value).format('YYYY-MM-DD'), this.eventGroupId, this.venue);
    this.initializeArr();
  }

  async onGroupChanged(id) {
    if (id == 'Select')
      this.eventGroupId = 0;
    else
      this.eventGroupId = parseInt(id);
    this.globalService.eventService = this.eventGroupId;
    await this._eventSearch.getEventsByDate(moment(this.globalService.eventDate).format('YYYY-MM-DD'), this.eventGroupId, this.venue);
    this.initializeArr();
  }

  async onVenueChanged(id) { 
    if (id == 'Select')
      this.eventVenueId = 0;    
    else
      this.eventVenueId = parseInt(id);
    if (this.eventVenueId == 0)
      this.venue = "";  
    else
      this.venue = this.venueArr.find(a => a.id == this.eventVenueId).name;
    this.globalService.eventLocation = this.eventVenueId;
    await this._eventSearch.getEventsByDate(moment(this.globalService.eventDate).format('YYYY-MM-DD'), this.eventGroupId, this.venue);
    this.initializeArr();
  }  
}
